// Справочник установки для выпадающих списков: коды с названиями на языке
// интерфейса.

import { useQuery } from "@tanstack/react-query";

import { referenceApi } from "./api";
import { localized } from "./localized";
import type { ReferenceList } from "./types";

export function useReference(list: ReferenceList) {
  const q = useQuery({
    queryKey: ["reference", list],
    queryFn: () => referenceApi.list(list),
    staleTime: 60_000,
  });
  const items = q.data ?? [];
  return {
    items,
    label: (code: string | null | undefined) =>
      code ? localized(items.find((i) => i.code === code)?.label, code) : "",
  };
}
